import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import {ListaCategoriaDropdown} from './lista_categorias.js'
import './cabecarios.css';

export class HeaderPrincipal extends Component{
    render(){
        return(
            <nav className="navbar navbar-expand-sm" id="principal">
                <div className="collapse navbar-collapse" id="principal-navbar">
                    <ul className="navbar-nav">
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Categorias
                            </a>

                            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <a className="dropdown-item" href="categoria">Categoria 1</a>
                                <a className="dropdown-item" href="categoria">Categoria 2</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item" href="categoria">Categoria 3</a>
                            </div>

                            
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#"> Como funciona </a>
                        </li>
                    </ul>

                    <ul className="navbar-nav navbar-right" id="principal-navbar-right">
                        <li className="nav-item">
                            <a href="#"> <FontAwesomeIcon icon="bell" size="lg" className="bell" color="#FFFFFF" /> </a> 
                        </li>
                        <li className="nav-item">
                            <a href="#"> <FontAwesomeIcon icon="comment-dots" size="lg" className="mensagem" color="#FFFFFF" /> </a> 
                        </li>
                        <li className="nav-item">
                            <a href="#"> <FontAwesomeIcon icon="user-circle"  size="lg"  color="#FFFFFF" /> </a> 
                        </li>
                    </ul>


                </div>
            </nav>
        );
    }
}

export class HeaderExterno extends Component{

    render(){
        return(
            <nav className="navbar navbar-expand-sm" id="externo">
                <div className="collapse navbar-collapse" >
                    <ul className="navbar-nav" id="externo-ul">
                        <li className="nav-item dropdown">
                            <a className="nav-link" href="#"> Extrato da conta </a>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link" href="#"> Cartões de Crédito Associados </a>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link" href="#"> Configurar Opções de Saque </a>
                        </li>
                    </ul>

                    <ul className="navbar-nav navbar-right" id="externo-right-ul">
                        <li className="nav-item">
                            <h2 id="saldo"> 200,00 Créditos </h2>
                        </li>
                        <li className="nav-item">
                            <a href='/usuario/comprar-credito' id="comprar" className="btn btn-primary-outline btn-sm"> Comprar créditos </a>                        
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
}
export class HeaderExternoProfissional extends Component{

    render(){
        return(
            <nav className="navbar navbar-expand-sm" id="externo">
                <div className="collapse navbar-collapse" >
                    <ul className="navbar-nav" id="externo-ul">
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to ="/profissional/perfil/servicos" >Serviços Prestados</Link>
                        </li>
                        <li className="nav-item dropdown">

                            <a className="nav-link" href="#"> Extrato da Conta </a>
                        </li>
                        <li className="nav-item dropdown">

                            <a className="nav-link" href="#"> Configurar Opções de Saque </a>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
}


export class HeaderInterno extends Component{

    render(){

        return(
            <nav className="navbar navbar-expand-sm" id="interno">
                <div className="collapse navbar-collapse nav-perfil">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to="/usuario/perfil/info"> Informações pessoais </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to="/usuario/perfil/senha"> Senha </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to="/usuario/perfil/notificacao"> Notificações e Alertas </Link>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to="/usuario/perfil/seguranca"> Segurança </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
}

export class HeaderInternoProfissional extends Component{


    constructor(){
        super();
        this.state = {
            usuario: []
        }
    }

    componentDidMount = () => {
        const {usuario} = this.props;

    }

    render(){
        return(
            <nav className="navbar navbar-expand-sm" id="interno">
                <div className="collapse navbar-collapse nav-perfil">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to= {{pathname : "/profissional/perfil/info"   } }   > Informações pessoais </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to= {{pathname : "#" , state: {usuario:this.props} }} > Informações financeiras </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to= {{pathname : "/profissional/perfil/senha"  }} > Senha </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link" to= {{pathname : "/profissional/perfil/notificacao"  }}> Notificações e Alertas </Link>
                        </li>

                        <li className="nav-item">
                            <Link className="nav-link" to= {{pathname : "/profissional/perfil/seguranca"  }}> Segurança </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        );
    }
}


